/**
 * 户口性质枚举
 */
export default Object.freeze([
    '农业户口',
    '非农户口',
])